export const FILE_CUSTOM_MIME_TYPE_TO_EXTENSION: Record<string, string> = {
  "application/acad": "dwg",
  "drawing/x-dwf": "dwf",
  "image/x-dwg": "dwg",
  "image/x-dxf": "dxf",
};
